import * as yup from "yup";
export const RFQlineItemSchema = yup.object().shape({
  particulars: yup.string(),
  itemUnit: yup.string(),
  itemQuantity: yup.string(),
  itemPrice: yup.string(),
  deliveryDate: yup.string(),
  notes: yup.string(),
});

export const RFQSchema = yup.object().shape({
  project: yup.string().required("Required"),
  vendor: yup.string().required("Required"),
  rfqType: yup.string().required("Required"),
  pdfStatus: yup.boolean(),
  countryOfSupply: yup.string(),
  placeOfSupply: yup.string(),
  generatedBy: yup.string(),
  vendorQuotationOrderDate: yup.date(),
  vendorQuotationOrderFor: yup.string(),
  lineItems: yup.array().of(RFQlineItemSchema),
});
